import {
  ClockCircleFilled,
  CustomerServiceFilled,
  BookFilled,
  MoneyCollectFilled,
} from "@ant-design/icons";

export const items = [
  "aqua",
  "deeppink",
  "darkkhaki",
  "blue",
  "green",
  "purple",
  "pink",
  "brown",
  "darkmagenta",
  "darksalmon",
  "dodgerblue",
  "firebrick",
  "darkviolet",
];

export const services_home = [
  {
    title: "Time Management",
    child: <ClockCircleFilled />,
    description:
      "We aim for providing hiring solutions for educational institutions. We recognize the importance of efficient and effective recruitment processes to ensure the smooth functioning of educational institutions. That's why we offer comprehensive hiring solutions designed to streamline the recruitment process and save valuable time.",
  },
  {
    title: "Best Quality Services",
    child: <CustomerServiceFilled />,

    description:
      "Our faculties are a team of highly qualified and extensively trained professionals. They have graduated from some of the most prestigious institutions around the world, which is a testament to their knowledge and expertise.They bring a wealth of experience and, creating a dynamic and engaging learning environment for our students.",
  },
  {
    title: "Practical Learning",
    child: <BookFilled />,
    description:
      "We emphasize practical learning through hands-on projects to enhance students' coding skills.They learn how to analyze requirements and implement them using programming languages. We believe that practical learning not only enhances technical competence but also nurtures critical thinking, creativity, and teamwork.",
  },
  {
    title: "Affordable Cost",
    child: <MoneyCollectFilled />,
    description:
      "We understand the importance of affordability and accessibility. Therefore, we offer our services at economical rates without compromising on quality.Join us on our mission to make coding education accessible and affordable for all, and together, let's unlock the boundless possibilities that coding offers.",
  },
];
